// Money/numerals/timers/order-codes stay LTR regardless of UI language (design guidance,
// bench-HOP-ORDER-DETAIL.CB-A) — always shape with en-US so digits/currency symbols never
// flip under Arabic. Pair with <Ltr> at the render site for bidi isolation in RTL flow.

export function formatMoney(amount: string | number | null | undefined, currency: string): string {
  if (amount === null || amount === undefined) return '—'
  const n = typeof amount === 'string' ? parseFloat(amount) : amount
  if (Number.isNaN(n)) return '—'
  try {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).format(n)
  } catch {
    return `${currency} ${n.toFixed(2)}`
  }
}

export function formatLbp(amount: string | number | null | undefined): string {
  if (amount === null || amount === undefined) return '—'
  const n = typeof amount === 'string' ? parseFloat(amount) : amount
  if (Number.isNaN(n)) return '—'
  return `${new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(n)} LBP`
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return new Intl.DateTimeFormat('en-US', {
    month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
  }).format(d)
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(d)
}
